// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3dMy2","productName":"Table_productName__3zXb1"};